<template>
	<div>
		<ul class="order ovw mar_b">
			<li :class="dataType == ''?'on':''"><a href="javascript:;" @click="queryData('',1)"><span>全部</span></a><i></i></li>
			<li :class="dataType == '2'?'on':''"><a href="javascript:;" @click="queryData('2',1)"><span>待出库</span></a><i></i></li>
			<li :class="dataType == '4'?'on':''"><a href="javascript:;" @click="queryData('4',1)"><span>已出库</span></a><i></i></li>
		</ul>
		<ul class="record_list2">
			<li v-for="(item,index) in list" :key="index" @click="detail(item)">
				<div class="order-no"><span>卡号：{{item.cardID}}</span><span>{{item.status_sname}}</span></div>
				<div>
					<div class="product-item" v-for="(item2,index2) in item.detail" :key="index2"><img :src="'/userfile/default/picture/' + item2.productID_simage" /><span>{{item2.productID_sname}}</span><h3>{{item2.num}}{{item2.productID_unit}}</h3></div>
				</div>
				<div class="order-no">
					<span>下单时间：{{item.orderCreated.replace('T',' ')}}</span>
					<span class="text-right"><a href="javascript:;" class="detail-btn">查看详情</a></span>
				</div>
			</li>
		</ul>
		<div class="no-data" v-if="list.length == 0"></div>
	</div>
</template>

<script>
import {
  GiftOrder_Query
} from "@/api/api.js"
export default {
  data () {
    return {
		dataType:'',
		list:[],
		page:1,
		size:20,
		isQuery:false
    }
  },
  methods:{
	  queryData(t,page){
		  let that = this;
		  if(that.isQuery){return;}

		  that.isQuery = true;
		  this.page = page; 
		  this.dataType = t;
		  if(this.page == 1){
			  this.list = [];
		  }

		  let query = {page:that.page,size:that.size,status:null};
	      if(that.dataType == '2' || that.dataType == '4'){
			query.status = parseInt(that.dataType);
		  }

		  GiftOrder_Query(query,function(res){
			  that.list = that.list.concat(res.data);
			  that.isQuery = false;
		  })
	  },
	  detail(t){
		  let that = this;
		  that.$router.push('giftorderdetail?id=' + t.id);
	  }
  },
  created:function(){
	  let that = this;
	  this.queryData(this.dataType,1);
	  window.onscroll = () => {
        let bottomOfWindow = document.documentElement.offsetHeight - document.documentElement.scrollTop - window.innerHeight <= 20
        if (bottomOfWindow  && !that.isQuery) {
          that.queryData(this.dataType,this.page + 1);
        }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/giftorder.vue